import { Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Component } from '@angular/core';
import { LogoHandlerComponent } from 'src/app/components/file-handler/logo-handler.component';
import { ChangePasswordComponent } from 'src/app/components/change-password.component';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiUser, UserWithProfile } from 'globals/store/user.data';
import { UploadStatus } from 'globals/store/files.model';
import { MatDialogModule } from '@angular/material/dialog';
import { PhotoComponent } from 'src/app/components/photo';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { DialogTitleComponent } from '../program/dialog-title';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.html',
    styleUrls: [`./profile.scss`],
    standalone: true,
    imports: [MatDialogModule, CommonModule, LogoHandlerComponent, PhotoComponent, MatProgressSpinnerModule, IconComponent, DialogTitleComponent, MatFormFieldModule, ChangePasswordComponent, FormsModule],
})
export class ProfileComponent extends Wrapper<ProfileComponent> {
    @ViewChild('profileForm') profileForm: ElementRef;
    @ViewChild('logoHandler') logoHandler: LogoHandlerComponent;
    @ViewChild('changePasswordComponent') changePasswordComponent: ChangePasswordComponent;
    @Output() close: EventEmitter<null> = new EventEmitter();
    user: UserWithProfile
    fromOAuth = false
    loading = true
    message = '';
    passwordError = false

    save_obj;
    _file = 'profile.ts';
    invalid_file = false;
    wait_for_reload = false;
    deletingPhoto = false
    changingPassword = false
    submittingPassword = false
    starting_first_last_name;

    constructor() {
      super()
      this.subCallback(this.store.select('user'), ({ user, fromOAuth, loading }) => {
        this.loading = loading
        this.fromOAuth = fromOAuth
        if(!this.starting_first_last_name) this.starting_first_last_name = user.firstName + ' ' + user.lastName;
        if (user.photoURL) { // deletingPhoto is set to true when deleting.  If a new photo is uploaded, then deletingPhoto should be set to false here
          this.deletingPhoto = false
        }
        if (!this.user) {
          this.user = {...user} // only populate most fields on first load, to avoid overwriting fields that haven't been updated yet
        } else {
          this.user.photoURL = user.photoURL
        }
        this.wait_for_reload = false
      })
      this.uiService.changePageTitle("Profile")
    }



    presave(profile) {
      // console.log({ profileValue: profile.value })
      // console.log('this.user ', this.user);
        this.save_obj = JSON.parse(JSON.stringify(profile.value)); // remove undefined properties
        const new_displayName = this.save_obj.firstName + ' ' + this.save_obj.lastName
        if(this.starting_first_last_name !== new_displayName){
          this.save_obj['displayName'] = new_displayName;
        }
        // console.log({'this.save_obj':this.save_obj});
        this.save_obj.uid = this.user.uid;
        this.save_obj.email = this.user.email;
        this.save(this.save_obj)
    }
    save(save_obj: Partial<JoiUser>){
      this.userService.updateUser(save_obj, false, {file:'profile.ts',function:'save',error:new Error(), message:'Saving error: You profile changes were not saved.'})
      this.close.emit()
    }
    statusChange(status: UploadStatus) {
      if (status.state) {
        if (status.state === 'uploading') {
          this.wait_for_reload = true;
        } else if (status.state === 'invalidFile') {
          this.invalid_file = true;
          setTimeout(() => this.invalid_file = false, 5000);
        }
      }
    }

    async deleteProfileImage(event) {
      const rect = event.target.getBoundingClientRect()
      const data: ConfirmDeleteData = {
        title: 'Delete Profile Image',
        para: 'Are you sure you want to delete your profile image?',
        rect,
        dialog: this.dialog
      }

      const del = await openConfirmDeleteGetResult(data)
      if (!del) return

      this.deletingPhoto = true // switch back to false when adding photo
      this.logoHandler.deletePhotoFromUrl(this.user.photoURL)

      this.userService.updateUser({photoURL: ''}, false, {file:'profile.ts',function:'save',error:new Error(), message:'Saving error: You profile changes were not saved.'})
      console.log("Can't figure out how to properly update event workforce users.  Might need to add photoURL to profiles and then be able to set it to null there when deleting a photo")

    }

    changePassword() {
      // return this.changingPassword = false
      const result = this.changePasswordComponent.passwordForm.value
      // console.log(result)

      result.email = this.user.email;
      this.submittingPassword = true
      this.auth.updatePassword(result).then(() => {
          this.passwordError = false
          this.message = 'Password updated successfully!'
          setTimeout(() => this.message = '', 4000);
          // console.log('Password updated', { result })
          this.changingPassword = false
          this.submittingPassword = false
      }).catch(({ code, message }) => {
          this.passwordError = true
          if (code === 'auth/wrong-password') {
            this.message = "You provided an incorrect password.  Password was not changed."
          } else {
            this.message = message
          }
          setTimeout(() => this.message = '', 4000);
          // console.log({ code, message });
          this.submittingPassword = false
      })


    }
}
